import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import MenuIcon from '@material-ui/icons/Menu';
import AddCircle from '@material-ui/icons/AddCircle';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Person from '@material-ui/icons/Person';
import Business from '@material-ui/icons/Business';
import Close from '@material-ui/icons/Close';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { useAuth } from "react-oidc-context";
import { Link } from 'react-router-dom';
import { LayoutContext } from 'App/Layout/store'
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const drawerWidth = 250;

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
    color: "#EEC131"
  },
  menuButtonHidden: {
    display: 'none',
  },
  homeLink: {
    textDecoration: 'none'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  botonIngresar: {
    color: "#EEC131"
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  yellowIcon: {
    color: "#EEC131"
  }
});

function Topbar(props) {
  const { classes } = props;
  const [abreNuevo, abrirNuevo] = useState(false);
  const [abreCuenta, abrirCuenta] = useState(false);
  const auth = useAuth();
  const layoutContext = useContext(LayoutContext);
  var esAdmin = layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre.startsWith("Administracion") && p.BLectura+p.BEscritura)
  var puedeCrearDTE = layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Emitidos" && p.BEscritura);
  var puedeCrearLibro = layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Libros" && p.BEscritura)
  return (

    <AppBar position="absolute"
      className={classNames(classes.appBar, props.showSidebar && classes.appBarShift)}>
      <Toolbar>
      {auth.isAuthenticated &&<IconButton className={classNames(
          classes.menuButton,
          props.showSidebar && classes.menuButtonHidden,
        )} color="inherit" aria-label="Menu" onClick={props.toggleSidebar}>
          <MenuIcon />
        </IconButton>}
        <Typography noWrap component={Link} className={classes.homeLink} to="/" variant="h6" color="inherit" style={{lineHeight:"4rem"}}>
        <img class="logo" src="dist/LogoAsyntecBlanco.png" style ={{height: "50px",padding: "10px 10px 0 0",float: "left"}} /> Asyntec DTE
          </Typography>
        <Typography noWrap component="h1" variant="subtitle1" color="inherit" className={classes.grow}>
          {props.title}
        </Typography>
        {auth.isAuthenticated ?
          <div>
            {puedeCrearDTE || puedeCrearLibro ? <IconButton
              aria-owns={abreNuevo ? 'menu-appbar' : undefined}
              aria-haspopup="true"
              onClick={e => !esAdmin?puedeCrearDTE?layoutContext.dispatch({ type: "toggleNuevaVenta" }):null:abrirNuevo(e.currentTarget)}
              color="inherit"
            >
              <AddCircle className={classes.yellowIcon} />
            </IconButton>:null}
            <Menu
              id="menu-appbar"
              anchorEl={abreNuevo}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(abreNuevo)}
              onClose={() => abrirNuevo(false)}
            >
              {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Emitidos" && p.BEscritura) && <MenuItem onClick={() => { layoutContext.dispatch({ type: "toggleNuevaVenta" }); abrirNuevo(false) }}>Venta</MenuItem>}
              {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Emitidos" && p.BEscritura) &&<MenuItem onClick={() => { layoutContext.dispatch({ type: "toggleCargaArchivoVenta" }); abrirNuevo(false) }}>Carga archivo de ventas</MenuItem>}
              {/* <MenuItem onClick={() => abrirNuevo(false)}>Compra</MenuItem> */}
              {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Emitidos" && p.BEscritura) && <MenuItem onClick={() => { layoutContext.dispatch({ type: "toggleNuevaVenta", tipo: 52 }); abrirNuevo(false) }}>Guía de Despacho</MenuItem>}
              {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Libros" && p.BEscritura) && <MenuItem onClick={() => {layoutContext.dispatch({ type: "toggleLibro",libro:{}}); abrirNuevo(false)}}>Libro Contable (IECV)</MenuItem>}
            </Menu>
            <IconButton
              aria-owns={abreCuenta ? 'menu-appbar' : undefined}
              aria-haspopup="true"
              onClick={e => abrirCuenta(e.currentTarget)}
              color="inherit"
            >
              <AccountCircle className={classes.yellowIcon} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={abreCuenta}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(abreCuenta)}
              onClose={() => abrirCuenta(false)}
            >
              <MenuItem onClick={() => { layoutContext.dispatch({ type: "toggleModalUsuario" }); abrirCuenta(false) }} className={classes.menuItem}>
                <ListItemIcon className={classes.icon}>
                  <Person />
                </ListItemIcon>
                <ListItemText classes={{ primary: classes.primary }} inset primary={auth.user.profile.preferred_username} />
              </MenuItem>
              <MenuItem onClick={() => { layoutContext.dispatch({ type: "toggleModalEmpresas" }); abrirCuenta(false) }} className={classes.menuItem}>
                <ListItemIcon className={classes.icon}>
                  <Business />
                </ListItemIcon>
                <ListItemText classes={{ primary: classes.primary }} inset primary={(layoutContext.state.datosEmpresa||{}).RazonSocial} />
              </MenuItem>
              <MenuItem onClick={() => { cookies.remove("empresa"); auth.signoutRedirect(); abrirCuenta(false) }} className={classes.menuItem}>
                <ListItemIcon className={classes.icon}>
                  <Close />
                </ListItemIcon>
                <ListItemText classes={{ primary: classes.primary }} inset primary="Cerrar Sesión" />
              </MenuItem>
            </Menu>
          </div>
          : <Button onClick={async ()=>{await auth.removeUser();await auth.signinRedirect()}} className={classes.botonIngresar} color="inherit">Ingresar</Button>
        }
      </Toolbar>
    </AppBar>

  );
}

Topbar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(React.memo(Topbar));